export default "__VITE_ASSET__Cea3cF4C__"